var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-sm btn-outline-info",on:{"click":_vm.exportAudit}},[_vm._v("Download Audit")])}
var staticRenderFns = []

export { render, staticRenderFns }